/**
 * @file 获取讲师获取学习任务列表
 * @author liudy
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    class_id: number; // int，班级编号，创建班级时为空
    page: number; // 页码;
    size: number; // 每页数量;
}

export const getClassAdminTaskList = (data: IInput): Promise<IListResponse<ITaskBaseInfo>> => {
    return fetchData(Api.CLASS_ADMIN_TASK_LIST, data).then((res: IListResponse<ITaskBaseInfo>) => {
        return res.data as IList<ITaskBaseInfo>;
    });
};
